import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ToastService} from "./toast.service";
import {AnaCodFiscaleDto, AnagraficaDto, AnagraficaPage, Asl, AslAbruzzo, Comune, Dizionario, Icd10, ServerInfo, Stato, Utente} from "../model/model";
import {catchError, Observable, shareReplay, tap, throwError} from "rxjs";
import {AuthService} from "./auth-service.service";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.apiUrl + '/api/v1/';
  private server_info_url: string = "serverInfo";
  private anagrafiche_url: string = "anagrafiche";
  private comuni_url: string = "comuni";
  private stati_url: string = "stati";
  private icd10_url: string = "icd10";
  private dizionari_url: string = "dizionari";
  private getUtenteUrl = "utente";
  private getAslUrl = "asl/all/parameter";
  private getAslAbruzzoUrl = "asl/abruzzo/parameter";
  private getAllAnagraficheUrl = "anagrafiche/all"
  constructor(private http: HttpClient,
              public toastService: ToastService,private auths:AuthService) {
  }

  public getServerInfo(): Observable<ServerInfo> {
    let url = this.baseUrl + this.server_info_url;
    return this.http.get<ServerInfo>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  getUtente(): Observable<Utente> {

    let url = this.baseUrl + this.getUtenteUrl

    return this.http.get<Utente>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  private asl$: Observable<Asl[]> | undefined;

  getAllAsl(): Observable<Asl[]> {

    let url = this.baseUrl + this.getAslUrl

    if (!this.asl$) {
      this.asl$ = this.http.get<Asl[]>(url).pipe(
        shareReplay()
      );
    }

    return this.asl$;
  }

  private aslAbruzzo$: Observable<AslAbruzzo[]> | undefined

  getAslAbruzzo(): Observable<AslAbruzzo[]> {
    
    let url = this.baseUrl + this.getAslAbruzzoUrl

    if(!this.aslAbruzzo$) {
      this.aslAbruzzo$ = this.http.get<AslAbruzzo[]>(url).pipe(
        shareReplay()
      );
    }

    return this.aslAbruzzo$;
  }

  public getAnagrafichePaginate(page: number = 0, size: number = 10, sortBy: string = 'cognome', direction: string = 'ASC', nome:string|undefined, cognome:string|undefined, cf:string|undefined, dataNascita:any,dataMorte:any,asl:string|undefined): Observable<AnagraficaPage> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('direction', direction);
    if(nome){
      nome = nome.toUpperCase();
      params=params.append('nome',nome);
    }
    if(cognome){
      cognome = cognome.toUpperCase();
      params=params.append('cognome',cognome);
    }
    if(cf){
      cf = cf.toUpperCase();
      params=params.append('codiceFiscale',cf);
    }
    if(asl)params=params.append('asl',asl);
    if(dataNascita) {
      params = params.append('annoNascita', dataNascita.year);
      params = params.append('meseNascita', dataNascita.month);
      params = params.append('giornoNascita', dataNascita.day);
    }
    if(dataMorte) {
      params = params.append('annoMorte', dataMorte.year);
      params = params.append('meseMorte', dataMorte.month);
      params = params.append('giornoMorte', dataMorte.day);
    }
    let url = this.baseUrl + this.anagrafiche_url;
    return this.http.get<AnagraficaPage>(url, { params })
      .pipe(catchError(error => this.handleError(error)));
  }
  getAnagrafica(id: number): Observable<AnagraficaDto> {
    return this.http.get(`${this.baseUrl}${this.anagrafiche_url}/${id}`)
      .pipe(catchError(error => this.handleError(error)));
  }

  checkCodiceFiscale(codiceFiscale: string, id:any): Observable<boolean> {
    const url =`${this.baseUrl}${this.anagrafiche_url}/${codiceFiscale}/checkCF`;
    return this.http.get<boolean>(url+(id?"?id="+id:""))
      .pipe(catchError(error => this.handleError(error)));
  }

  getComuni(anno?:number): Observable<Comune[]|any> {
    return this.http.get(this.baseUrl+this.comuni_url+(anno?"?anno="+anno:""))
      .pipe(catchError(error => this.handleError(error)));
  }
  getStati(): Observable<Stato[]|any> {
    return this.http.get(`${this.baseUrl}${this.stati_url}`)
      .pipe(catchError(error => this.handleError(error)));
  }

  getAllAnagrafiche(): Observable<AnaCodFiscaleDto[]|any> {
    return this.http.get(`${this.baseUrl}${this.getAllAnagraficheUrl}`)
      .pipe(catchError(error => this.handleError(error)));
  }

  getIcd10(): Observable<Icd10[]|any> {
    return this.http.get(`${this.baseUrl}${this.icd10_url}`)
      .pipe(catchError(error => this.handleError(error)));
  }

  getDizionari(): Observable<Dizionario[]|any> {
    return this.http.get(`${this.baseUrl}${this.dizionari_url}`)
      .pipe(catchError(error => this.handleError(error)));
  }

  deleteAnagrafica(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}${this.anagrafiche_url}/${id}`)
      .pipe(catchError(error => this.handleError(error)));
  }

  saveOrUpdateAnagrafica(anagraficaDto: AnagraficaDto): Observable<any> {
    return this.http.put<number>(this.baseUrl+this.anagrafiche_url, anagraficaDto)
      .pipe(tap(value => this.toastService.showSuccess("Salvataggio avvenuto con successo ")),catchError(error => this.handleError(error)));
  }

  handleError(error: Response | any) {
    console.error('************ handleError ' + JSON.stringify(error));
    if(error?.status==401){
      this.auths.logout();
    } else if(error?.status==0){
      this.toastService.showError("Attenzione il server non sembra raggiungibile");
    } else {
      this.toastService.showError(error.error ? error.error.message : error.message);
    }
    return throwError(error);
  }
}
